<app-navbar></app-navbar>
<div class="banner"></div>

<!-- Formulario de búsqueda estilo Booking.com -->
<div class="search-container">
  <div class="search-wrapper">
    <h2 class="search-title">Busca el alojamiento de tu gusto</h2>
    <div class="search-form">
      <div class="search-fields">
        <!-- Campo de fechas -->
        <div class="search-field dates-field">
          <div class="field-content dates-content">
            <div class="date-input-group">
              <div class="date-input">
                <label class="field-label">Fecha de entrada</label>
                <input
                  type="date"
                  [(ngModel)]="searchCriteria.checkIn"
                  class="field-input date-field">
              </div>
              <div class="date-separator">—</div>
              <div class="date-input">
                <label class="field-label">Fecha de salida</label>
                <input
                  type="date"
                  [(ngModel)]="searchCriteria.checkOut"
                  class="field-input date-field">
              </div>
            </div>
          </div>
        </div>

        <!-- Campo de huéspedes -->
        <div class="search-field guests-field">
          <div class="field-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A3.01 3.01 0 0 0 17.06 6h-1.12c-.8 0-1.54.37-2.01.99L12 10l-1.93-3.01C9.6 6.37 8.86 6 8.06 6H6.94c-1.24 0-2.27.86-2.86 2.37L1.5 16H4v6h2v-6h2.5l1.5-4.5L12 14l1.5-2.5L15 16h2.5v6h2.5z"/>
            </svg>
          </div>
          <div class="field-content">
            <label class="field-label">Huéspedes</label>
            <div class="guests-summary" (click)="toggleGuestsDropdown()">
              <span>{{getGuestsSummary()}}</span>
              <svg class="dropdown-arrow" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
              </svg>
            </div>

            <!-- Dropdown de huéspedes -->
            <div class="guests-dropdown" [class.show]="showGuestsDropdown">
              <div class="guest-row">
                <div class="guest-info">
                  <span class="guest-type">Adultos</span>
                  <span class="guest-age">Edad: 13 años o más</span>
                </div>
                <div class="guest-controls">
                  <button type="button" class="guest-btn" (click)="updateGuests('adults', -1)" [disabled]="searchCriteria.adults <= 1">−</button>
                  <span class="guest-count">{{searchCriteria.adults}}</span>
                  <button type="button" class="guest-btn" (click)="updateGuests('adults', 1)">+</button>
                </div>
              </div>

              <div class="guest-row">
                <div class="guest-info">
                  <span class="guest-type">Niños</span>
                  <span class="guest-age">De 2 a 12 años</span>
                </div>
                <div class="guest-controls">
                  <button type="button" class="guest-btn" (click)="updateGuests('children', -1)" [disabled]="searchCriteria.children <= 0">−</button>
                  <span class="guest-count">{{searchCriteria.children}}</span>
                  <button type="button" class="guest-btn" (click)="updateGuests('children', 1)">+</button>
                </div>
              </div>

              <div class="guest-row">
                <div class="guest-info">
                  <span class="guest-type">Bebés</span>
                  <span class="guest-age">Menos de 2 años</span>
                </div>
                <div class="guest-controls">
                  <button type="button" class="guest-btn" (click)="updateGuests('babies', -1)" [disabled]="searchCriteria.babies <= 0">−</button>
                  <span class="guest-count">{{searchCriteria.babies}}</span>
                  <button type="button" class="guest-btn" (click)="updateGuests('babies', 1)">+</button>
                </div>
              </div>

              <div class="guest-row">
                <div class="guest-info">
                  <span class="guest-type">Mascotas</span>
                  <span class="guest-age">¿Traes un animal de servicio?</span>
                </div>
                <div class="guest-controls">
                  <button type="button" class="guest-btn" (click)="updateGuests('pets', -1)" [disabled]="searchCriteria.pets <= 0">−</button>
                  <span class="guest-count">{{searchCriteria.pets}}</span>
                  <button type="button" class="guest-btn" (click)="updateGuests('pets', 1)">+</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botones de búsqueda -->
        <div class="search-buttons">
          <button class="search-button" (click)="onSearch()">
            <span>Buscar Disponibles</span>
          </button>
          <button class="view-all-button" (click)="viewAllHostings()">
            <span>Ver Todos</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<h1>Lista de Alojamientos</h1>

@if (isLoading && hostings.length === 0) {
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>Cargando alojamientos...</p>
  </div>
}

<div class="cards-container">
  @for (hosting of hostings; track trackByDuplicated($index, hosting.id)) {
    <div class="hosting-card">
      <!-- Mantén tu estructura de card existente -->
      <div class="card-image-container">
        <img [src]="hosting.images" alt="{{hosting.name}}" class="card-image">
        <button class="favorite-button">
          <svg class="heart-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  fill="none"/>
          </svg>
        </button>
      </div>
      <div class="card-content">
        <h3 class="card-title">{{ hosting.name }}</h3>
        <p class="card-price">{{ hosting.room?.price_per_night | currency:'COP':'symbol-narrow':'1.0-0' }} noche</p>
      </div>
      <div class="card-rating">
        ★ {{ hosting.review.average | number:'1.1-1' }}
      </div>
      <div class="button-container">
        <button class="detail-button" [routerLink]="['/hosting-detail', hosting.id]">Ver más detalles</button>
      </div>
    </div>
  }
</div>

@if (isLoading && hostings.length > 0) {
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>Cargando más alojamientos...</p>
  </div>
}

@if (!hasMore && hostings.length > 0) {
  <div class="end-message">
    <p>Has visto todos los alojamientos disponibles</p>
  </div>
}

<app-footer></app-footer>
